import rebrandStyles from '@jobcase/react_pattern_library/styles/rebrand';

import { htmlToReactParser } from './hiringEvents';

import {
  routeToContactJobcase,
  routeToLogout,
  routeToNotifications,
  routeToSettings,
  routeToUserRoles,
} from '../redux/nodes/router/actions';

export const getMenuItems = (notificationsCount) => {
  const NotificationCountStyles = `
    align-items: center;
    background-color: ${rebrandStyles.color.secondaryColor};
    border-radius: 50%;
    color: ${rebrandStyles.color.jobcaseWhiteColor};
    display: ${notificationsCount > 0 ? 'inline-flex' : 'none'};
    font-size: ${rebrandStyles.font.fontSize.tertiary};
    font-weight: 600;
    height: 19px;
    justify-content: center;
    line-height: 21px;
    margin-left: ${rebrandStyles.spacing.tiny}px;
    margin-top: 0;
    text-align: center;
    vertical-align: middle;
    width: 19px;
  `;

  const MENU_ITEMS = [
    {
      onClick: routeToSettings,
      text: 'My Settings',
    },
    {
      onClick: routeToNotifications,
      text: htmlToReactParser(
        `My Notifications<div style="${NotificationCountStyles}">${notificationsCount}</div>`,
      ),
    },
    {
      onClick: routeToUserRoles,
      text: 'Team Management',
    },
    {
      onClick: routeToContactJobcase,
      text: 'Contact Jobcase',
    },
    {
      onClick: routeToLogout,
      text: 'Sign out',
      hasTopDivider: true,
    },
  ];
  return MENU_ITEMS;
};

export default { getMenuItems };
